import { render, staticRenderFns } from "./AdminSpecialistBookingsCalendar.vue?vue&type=template&id=92ab1ef6"
import script from "./AdminSpecialistBookingsCalendar.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistBookingsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports